module.exports = __webpack_public_path__ + "HP_Latex_700-800.jpg?2d45efe64eda66a1b235547beb5d77ea";